import {array, boolean, object, string} from 'yup'
import {howToGroup, isOfficeGroup, isPreviousComparison, officeGroup, offices, timeToCompare, yearlyComp} from '@signals'
import { HOW_TO_GROUP } from 'Pages/BusinessLogistics/BI/Page/@constants'

export const BISchema = object({
	reportType: string()
		.required('Must provide at least one grouping method'),
	officePickupID: array()
        .test("isOfficePickupID", "Pickup Office is required", () => isOfficeGroup.value || !!offices.value?.length).nullable(),
    officeGroupID: array()
        .test("isOfficeGroupID", "Pickup Group Office is required", () => !isOfficeGroup.value || !!officeGroup.value?.length).nullable(),
	startBookingDate: string()
		.required('Booking Start Date is required')
		.matches(/^\d{8}$/, 'Invalid date format (YYYYMMDD)'),
	endBookingDate: string()
		.required('Booking End Date is required')
		.matches(/^\d{8}$/, 'Invalid date format (YYYYMMDD)'),
	startPickupDate: string()
		.required('Pickup Date Range is required')
		.matches(/^\d{8}$/, 'Invalid date format (YYYYMMDD)'),
	endPickupDate: string()
		.required('Pickup End Date is required')
		.matches(/^\d{8}$/, 'Invalid date format (YYYYMMDD)'),
	lor: array().min(1, 'Length of Rental is required'),
	currency: string()
		.required('Currency is required'),
	categoryID: array().test('category', "Category is required", value => howToGroup.value !== HOW_TO_GROUP.CATEGORY_PICKUP || !!value?.length),
	isPreviousComparison: boolean()
		.test('isPreviousMarked', 'Number of Days/Years in the past to compare with', () =>
			!(isPreviousComparison.value && !parseInt(timeToCompare.value))
		)
		.test('isWithinValidRange', 'Years must comprehend between 1 and 10 and days between 1 and 365', () =>
			!(isPreviousComparison.value && parseInt(timeToCompare.value) > (yearlyComp.value ? 10 : 365))
		),
})

